module.exports = __webpack_public_path__ + "static/station-place-c0fa65dad363ba2e07f2b33c9ac080f5.jpg";